import { render, staticRenderFns } from "./ItemDetailBar.vue?vue&type=template&id=bc130dd6&"
import script from "./ItemDetailBar.vue?vue&type=script&lang=js&"
export * from "./ItemDetailBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports